import { Trans } from '@lingui/macro'

export default function formatError(error, message, type) {
  let errorMessage = message
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data?.detail
  ) {
    errorMessage = error.response.data?.detail
  } else if (type) {
    function getWord() {
      if (type === 'create') {
        return <Trans>created</Trans>
      } else if (type === 'update') {
        return <Trans>updated</Trans>
      } else if (type === 'delete') {
        return <Trans>removed</Trans>
      } else if (type === 'read') {
        return <Trans>loaded</Trans>
      }
    }
    return (
      <span>
        <strong>{errorMessage}</strong> <Trans>could not be</Trans> {getWord()}
      </span>
    )
  }
  return errorMessage
}

export function getErrorMessage(apolloError) {
  if (apolloError.networkError?.message) {
    return apolloError.networkError.message
  }
  if (apolloError?.graphQLErrors?.[0]?.message) {
    return apolloError?.graphQLErrors?.[0]?.message
  }
  return 'Unknown error'
}
